import { takeEvery } from 'redux-saga/effects';
import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { CoreActionCreator } from '../core/resourceStoreTypes';
import * as actions from './customersActions';
import { getLastSyncDate } from './customersSelectors';
import { transformCustomersToRequestData, transformResponseToCustomers } from './customersTransformers';
import type { CustomerProps } from './customersTypes';

const mkQcsSyncCustomersConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<CustomerProps>();

const mkResourceConfig = (successAction: CoreActionCreator<any, any>, failureAction: CoreActionCreator<any, any>) =>
  mkQcsSyncCustomersConfig({
    resourceName: 'customers',
    resourceBaseUrl: '/businesses/customers',
    getLastSyncDate,

    transformResponseToResources: transformResponseToCustomers,
    transformResourceToRequestData: transformCustomersToRequestData,
    applyResourceFromCRUDResponse: true,

    successAction,
    failureAction,
  });

export function* getCustomersActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getCustomersSuccess, actions.getCustomersFailure);
  yield resourceSagaUtils.takeAndDebounce(actions.getCustomers, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export function* createCustomersActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createCustomerSuccess, actions.createCustomerFailure);
  yield takeEvery(actions.createCustomer.type, resourceSagaUtils.qcsSyncCreateResource<CustomerProps>, resourceConfig);
}

export function* updateCustomersActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateCustomerSuccess, actions.updateCustomerFailure);
  yield takeEvery(actions.updateCustomer.type, resourceSagaUtils.qcsSyncUpdateResource<CustomerProps>, resourceConfig);
}

export function* deleteCustomersActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteCustomerSuccess, actions.deleteCustomerFailure);
  yield takeEvery(actions.deleteCustomer.type, resourceSagaUtils.qcsSyncDeleteResource<CustomerProps>, resourceConfig);
}

export default [
  getCustomersActionWatcher,
  createCustomersActionWatcher,
  updateCustomersActionWatcher,
  deleteCustomersActionWatcher,
];
